var map = {
	"./BackBtnLayout.vue": 1987,
	"./BaseLayout.vue": 1111,
	"./ClinicHistorySectionsSidebar.vue": 1991,
	"./ForumNavbar.vue": 1995,
	"./HealthyHabitsLayout.vue": 2008,
	"./InternalReducedLayout.vue": 2012,
	"./Opensalud360Layout.vue": 2017,
	"./OpensaludEmpresasLayout.vue": 2024,
	"./OpensaludLayout.vue": 2028,
	"./OpensaludPacientesLayout.vue": 2032,
	"./OpensaludProfesionalesLayout.vue": 2036,
	"./PrivateLayout.vue": 2040,
	"./PublicExtendedLayout.vue": 2072,
	"./PublicLayout.vue": 2076,
	"./PublicMenuLayout.vue": 2080,
	"./PublicMenuLayoutV2.vue": 174,
	"./PublicMobileMenuLayout.vue": 2084,
	"./PublicReducedLayout.vue": 1183,
	"./PublicReducedLayoutDynamic.vue": 2091,
	"./patient/GoFreedom.vue": 2095,
	"./patient/GoOpensaludpass.vue": 2099,
	"./patient/GoTeleconsultation.vue": 2103,
	"./patient/GoTmc.vue": 2107,
	"./patient/GoWellwo.vue": 2111,
	"./patient/SearchTab.vue": 1285,
	"./professional/customHeader.vue": 1257,
	"./professional/customaFooter.vue": 2115
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1986;


//////////////////
// WEBPACK FOOTER
// ./src/components/layouts [A-Z]\w+\.(vue|js)$
// module id = 1986
// module chunks = 116